import React from 'react';
import { Outlet } from 'react-router-dom';
import AccessDeniedCard from '../../../components/AccessDeniedCard';
import { usePermissions } from '../../../hooks/usePermissions';
import { useRoleModuleLabel } from '../../../hooks/useRoleModuleLabel';
import {
  READ_BULK_UPLOAD,
  READ_PURCHASE_CREDIT_NOTE,
  READ_PURCHASE_INVOICE,
  READ_SUPPLIER,
} from '../../../constants/eInvoicePermissions';
import { BULK_UPLOAD_MODULE_KEY } from '../../settings/constants/roleModules';

export default function PurchaseBulkUploadAccessLayout() {
  const { loading, hasEInvoicePermission } = usePermissions();
  const title = useRoleModuleLabel(BULK_UPLOAD_MODULE_KEY);

  if (loading) {
    return null;
  }

  const canReadPurchases =
    hasEInvoicePermission(READ_PURCHASE_INVOICE) || hasEInvoicePermission(READ_PURCHASE_CREDIT_NOTE);
  const canReadSupplier = hasEInvoicePermission(READ_SUPPLIER);
  const isAllowed = hasEInvoicePermission(READ_BULK_UPLOAD) && (canReadPurchases || canReadSupplier);

  if (!isAllowed) {
    return <AccessDeniedCard title={title} />;
  }

  return <Outlet />;
}
